import config from '../../config';
// Action Types
export const ASSIGN_ROLLNO_REQUEST = 'ASSIGN_ROLLNO_REQUEST';
export const ASSIGN_ROLLNO_SUCCESS = 'ASSIGN_ROLLNO_SUCCESS';
export const ASSIGN_ROLLNO_FAILURE = 'ASSIGN_ROLLNO_FAILURE';


// Action Creators
export const assignRollNoRequest = () => ({
  type: ASSIGN_ROLLNO_REQUEST,
});

export const assignRollNoSuccess = (message) => ({
  type: ASSIGN_ROLLNO_SUCCESS,
  payload: message,
});

export const assignRollNoFailure = (error) => ({
  type: ASSIGN_ROLLNO_FAILURE,
  payload: error,
});

// Async Action (Thunk)
export const assignRollNo = (student_id, roll_no) => {
  return async (dispatch) => {
    dispatch(assignRollNoRequest());

    try {
      // const response = await axios.get(`${config.apiBaseUrl}/payments/getBalances.php`);
      const response = await fetch(`${config.apiBaseUrl}/students/update/alloteRollNo.php`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ student_id, roll_no }),
      });

      const data = await response.json();

      if (response.ok) {
        dispatch(assignRollNoSuccess(data.message));
      } else {
        dispatch(assignRollNoFailure(data.message || 'Roll No assignment failed'));
      }
    } catch (error) {
      dispatch(assignRollNoFailure(error.message || 'An error occurred'));
    }
  };
};
